export type PosNavigationIntent = {
  openRecarga?: boolean;
};

let pendingIntent: PosNavigationIntent | null = null;

export function setPosNavigationIntent(intent: PosNavigationIntent): void {
  if (pendingIntent != null) return;
  pendingIntent = intent;
}

export function consumePosNavigationIntent(): PosNavigationIntent | null {
  const intent = pendingIntent;
  pendingIntent = null;
  return intent;
}
